// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"70":"3336a558","262":"1479c186","428":"3336a558"}[chunkId] + ".chunk.css";
};